import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

const getImageDataFromURL = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      const canvas = document.createElement("canvas");
   
      const maxWidth = 60;
      const maxHeight = 28;
      let width = img.width;
      let height = img.height;
      
    
      const aspectRatio = width / height;
      
      if (width > height) {
        if (width > maxWidth) {
          width = maxWidth;
          height = width / aspectRatio;
        }
      } else {
        if (height > maxHeight) {
          height = maxHeight;
          width = height * aspectRatio;
        }
      }
      
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL("image/png"));
    };
    img.src = url;
  });
};

export const generatePaymentAdvicePDF = async ({
  rowData,
  pytAdvNo,
  pytAdvDt,
  propName,
  residentName,
  mobileNo,
  email,
  bookNo,
  balAmount,
  dueDt,
  monthNames,
  paymentUrl,
  logo
}) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  let yPos = 12;
  const pageWidth = doc.internal.pageSize.width;
  const margin = 15;
  const usableWidth = pageWidth - (margin * 2);

  if (logo) {
    const logoData = await getImageDataFromURL(logo);
    doc.addImage(logoData, 'PNG', margin, 8, undefined, undefined);
  }

  doc.setTextColor(99, 91, 255);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(propName || "Clanbridge Living Pvt Ltd", margin + 45, 16);

  doc.setFontSize(14);
  doc.setTextColor(99, 91, 255);
  doc.text("INVOICE", pageWidth - margin - 25, 16, { align: "right" });

  yPos = 22;
  doc.setDrawColor(99, 91, 255);
  doc.setLineWidth(0.5);
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 8;
  const formatDate = (date) => {
    if (!date || date === "0001-01-01T00:00:00") return moment().format("DD/MM/YYYY");
    return moment(date, "DD/MM/YYYY").format("DD/MM/YYYY");
  };


  const detailsData = [
    [
      { content: "RESIDENT DETAILS", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 8, fontStyle: 'bold' }, colSpan: 2 },
      { content: "INVOICE DETAILS", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 8, fontStyle: 'bold' }, colSpan: 2 }
    ],
    [
      { content: "Full Name", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: residentName || "N/A", styles: { fontSize: 7.5 } },
      { content: "Invoice No", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: pytAdvNo || "N/A", styles: { fontSize: 7.5 } }
    ],
    [
      { content: "Mobile", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: mobileNo || "N/A", styles: { fontSize: 7.5 } },
      { content: "Invoice Date", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: formatDate(pytAdvDt) || "N/A", styles: { fontSize: 7.5 } }
    ],
    [
      { content: "Email", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: email || "N/A", styles: { fontSize: 7.5 } },
      { content: "Due Date", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: dueDt ? formatDate(dueDt) : "N/A", styles: { fontSize: 7.5 } }
    ],
    [
      { content: "Address", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: "N/A", styles: { fontSize: 7.5 } },
      { content: "Advice No", styles: { fontStyle: "bold", fontSize: 7.5 } },
      { content: bookNo || "N/A", styles: { fontSize: 7.5 } }
    ]
  ];

  doc.autoTable({
    startY: yPos + 2,
    body: detailsData,
    theme: "grid",
    styles: {
      fontSize: 7.5,
      cellPadding: 2,
      lineColor: [200, 200, 200],
      lineWidth: 0.2,
      valign: 'middle'
    },
    columnStyles: {
      0: { cellWidth: 28 },
      1: { cellWidth: 55 },
      2: { cellWidth: 28 },
      3: { cellWidth: 55 }
    },
    margin: { left: margin, right: margin },
    tableWidth: 'auto'
  });

  yPos = doc.lastAutoTable.finalY + 5;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0);
  doc.text("PARTICULARS & ITEMIZED CHARGES", margin, yPos);

  
  yPos += 4;

  const taxableValue = parseFloat(balAmount) || 58000;
  const gstAmount = taxableValue * 0.18;
  const subtotal = taxableValue - gstAmount;

  const chargesData = [
    [
      { content: "S/N", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 7.5, fontStyle: 'bold' } },
      { content: "DESCRIPTION", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 7.5, fontStyle: 'bold' } },
      { content: "QTY", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 7.5, fontStyle: 'bold' } },
      { content: "RATE (RS)", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 7.5, fontStyle: 'bold' } },
      { content: "GST (18%)", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 7.5, fontStyle: 'bold' } },
      { content: "AMOUNT (RS)", styles: { halign: "center", fillColor: [99, 91, 255], textColor: [255,255,255], fontSize: 7.5, fontStyle: 'bold' } }
    ],
    [
      { content: "1", styles: { halign: "center", fontSize: 7.5 } },
      { 
        content: `Hostel Accommodation Fee - Installment 1\nStudent: ${residentName || "N/A"} | Ref: ${bookNo || "N/A"}`,
        styles: { fontSize: 6.5 }
      },
      { content: "1", styles: { halign: "center", fontSize: 7.5 } },
      { content: subtotal.toFixed(2), styles: { halign: "right", fontSize: 7.5 } },
      { content: gstAmount.toFixed(2), styles: { halign: "right", fontSize: 7.5 } },
      { content: taxableValue.toFixed(2), styles: { halign: "right", fontSize: 7.5 } }
    ],
    [
      { content: "", colSpan: 3, styles: { fillColor: [249,250,251] } },
      { content: "Subtotal / Taxable Value:", styles: { fontStyle: "bold", halign: "right", fontSize: 7.5, fillColor: [249,250,251] } },
      { content: gstAmount.toFixed(2), styles: { halign: "right", fontSize: 7.5, fillColor: [249,250,251] } },
      { content: taxableValue.toFixed(2), styles: { halign: "right", fontSize: 7.5, fillColor: [249,250,251] } }
    ]
  ];

  doc.autoTable({
    startY: yPos,
    body: chargesData,
    theme: "grid",
    styles: {
      fontSize: 7.5,
      cellPadding: 2,
      lineColor: [200, 200, 200],
      lineWidth: 0.2,
    },
    columnStyles: {
      0: { cellWidth: 10 },
      1: { cellWidth: 75 }, 
      2: { cellWidth: 12 },
      3: { cellWidth: 28 },
      4: { cellWidth: 25 },
      5: { cellWidth: 32 }
    },
    margin: { left: margin, right: margin },
    tableWidth: 'auto'
  });

  // Grand Total
  yPos = doc.lastAutoTable.finalY + 4;
  doc.setFontSize(7.5);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0);
  doc.text(`Amount in Words: Fifty-Eight Thousand Rupees and Zero Paise Only`, margin, yPos);
  
  yPos += 5;
  doc.setFontSize(12);
  doc.setTextColor(99, 91, 255);
  doc.text(`GRAND TOTAL DUE: Rs. ${taxableValue.toFixed(2)}`, margin, yPos);


  if (paymentUrl) {
    yPos += 8;
    const buttonWidth = 40;
    const buttonHeight = 7;
    const buttonX = (pageWidth / 2) - (buttonWidth / 2);
    
    doc.setFillColor(99, 91, 255);
    doc.setDrawColor(99, 91, 255);
    doc.setLineWidth(0.5);
    doc.roundedRect(buttonX, yPos, buttonWidth, buttonHeight, 2, 2, 'FD');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    
    const text = "PAY NOW";
    const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    const textX = (pageWidth / 2) - (textWidth / 2);
    const textY = yPos + 5;

    doc.textWithLink(text, textX, textY, {
      url: paymentUrl
    });

    yPos += buttonHeight + 5;
    
   
    doc.setFontSize(6);
    doc.setTextColor(100);
    doc.setFont('helvetica', 'normal');
    doc.text("Clicking above will direct you to the secure digital payment portal.", pageWidth / 2, yPos, { align: "center" });
    yPos += 6;
  }

  yPos += 3;
  doc.setFontSize(9);
  doc.setTextColor(0);
  doc.setFont('helvetica', 'bold');
  doc.text("TERMS & CONDITIONS", margin, yPos);

  const terms = [
    "1. Payment Timeline: This invoice is a formal demand for payment. Dues must be fully cleared on or before the specified Due Date.",
    "2. Late Payment Penalty: Delay beyond the due date automatically attracts a late fee penalty as per company policy, calculated from the following day.",
    "3. Suspension of Amenities: Continued default past the due date reserves management the right to temporarily suspend auxiliary hostel services (Wi-Fi, mess, housekeeping) or cancel accommodation privileges.",
    "4. No Auto-Adjustment: Rent and operational invoices cannot be automatically adjusted against the security deposit, which is strictly reserved for post-checkout clearance.",
    "5. Discrepancies: Any billing discrepancies or disputes must be reported in writing within 48 hours of invoice issuance, failing which the invoice will be deemed accepted and final.",
    "6. Taxation: Includes GST and statutory levies at current prevailing government rates. Any retrospective tax updates will be adjusted.",
    "7. Realization: Invoice is considered settled only after funds are fully cleared and credited to the account of Clanbridge Living Pvt. Ltd.",
    "8. Non-Transferability: Involved amounts, credits, or room bookings are strictly non-transferable to any other resident or third party.",
    "9. Electronic Document: Computer-generated tax invoice; does not require physical or digital signatures to be legally binding."
  ];

  yPos += 4;
  doc.setFontSize(6.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(80);

  terms.forEach((term) => {
    const lines = doc.splitTextToSize(term, usableWidth);
    doc.text(lines, margin, yPos);
    yPos += (lines.length * 3) + 1.5;
  });

  // Footer
  yPos += 4;
  if (yPos > 275) {
    doc.addPage();
    yPos = 20;
  }
  
  doc.setFontSize(7.5);
  doc.setTextColor(99, 91, 255);
  doc.setFont('helvetica', 'bold');
  doc.text("Thank you for choosing Clanbridge Living Pvt Ltd", pageWidth / 2, yPos, { align: "center" });
  
  yPos += 4.5;
  doc.setFontSize(6.5);
  doc.setTextColor(100);
  doc.setFont('helvetica', 'normal');
  doc.text("For billing or payment queries, contact: accounts@clanbridge.com", pageWidth / 2, yPos, { align: "center" });


  const pdfBlob = doc.output('blob');
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.readAsDataURL(pdfBlob);
  });
};

export const getPDFBase64 = async (params) => {
  return await generatePaymentAdvicePDF(params);
};

export default {
  generatePaymentAdvicePDF,
  getPDFBase64
};